// Placeholder panel shown while a vineyard's details (or the lazy-loaded
// panel code itself) load. When the name is already known (search results
// carry it), it renders immediately with shimmer lines for the rest — no
// flash of other content in between. Lives outside the lazy panel chunks so
// it is always available instantly.
export default function DetailSkeleton({ name, onClose }) {
  return (
    <aside className="detail">
      <header className="detail__header">
        {/* back lives in the top-left map bar; only fly-through passes onClose */}
        {onClose && <button className="detail__back" onClick={onClose}>←</button>}
        <div className="detail__title-wrap">
          <h2 className="detail__title">{name || ' '}</h2>
          <p className="detail__sub"><span className="skeleton-line skeleton-line--sub" /></p>
        </div>
      </header>
      <div className="detail__body">
        {[88, 62, 76, 54, 70, 42].map((w, i) => (
          <span key={i} className="skeleton-line" style={{ width: `${w}%` }} />
        ))}
      </div>
    </aside>
  );
}
